import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SubscriptionType } from '../../../types/Student';

const initialState:SubscriptionType = {
    semester: 0,
    year: 0,
    idEnrollment: ''
}

const subscriptionSlice = createSlice({
  name: "subscriptionForm",
  initialState,
  reducers: {
    setSubscriptionData:(state, action:PayloadAction<SubscriptionType>)=>({...action.payload}), 
    resetSubscriptionData :()=>({...initialState})
  }
});

export const {setSubscriptionData,resetSubscriptionData } = subscriptionSlice.actions

export default subscriptionSlice.reducer